import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "card-header border-0 bg-success" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
    /*#__PURE__*/_createElementVNode("h4", { class: "card-title m-0" }, [
      /*#__PURE__*/_createElementVNode("p", { class: "fw-bolder text-light m-0 fs-2" }, " Status of Training Activities ")
    ])
  ])
], -1)
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "table-responsive mt-3" }
const _hoisted_4 = { class: "table table-bordered table-row-bordered table-row-gray-400 align-middle border border-gray-400 gs-2 gy-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder bg-light text-primary" }, [
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      class: "align-middle border border-gray-400"
    }, "Sl"),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      class: "align-middle border border-gray-400"
    }, "Tranche"),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      class: "align-middle border border-gray-400"
    }, "Total Target (As Per Contract)"),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      class: "align-middle border border-gray-400"
    }, "Enrollment"),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      class: "align-middle border border-gray-400"
    }, "No. of Female Trainees"),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      class: "align-middle border border-gray-400"
    }, "Certification"),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      class: "align-middle border border-gray-400"
    }, "Job Placement"),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"text-align":"center"},
      class: "align-middle border border-gray-400"
    }, "% on Certified")
  ])
], -1)
const _hoisted_6 = { style: {} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card", _ctx.widgetClasses])
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("table", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("tbody", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.tmsdashboardInfo, (info, key) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: key,
                class: "border border-gray-400 text-center"
              }, [
                _createElementVNode("td", null, _toDisplayString(info?.sl), 1),
                _createElementVNode("td", null, _toDisplayString(info?.tranche), 1),
                _createElementVNode("td", null, _toDisplayString(Number(info?.targetTrainee).toLocaleString()), 1),
                _createElementVNode("td", null, _toDisplayString(Number(info?.enrollment).toLocaleString()), 1),
                _createElementVNode("td", null, _toDisplayString(Number(info?.femaleEnrollment).toLocaleString()), 1),
                _createElementVNode("td", null, _toDisplayString(Number(info?.certification).toLocaleString()), 1),
                _createElementVNode("td", null, _toDisplayString(Number(info?.job_placement).toLocaleString()), 1),
                _createElementVNode("td", null, _toDisplayString(info?.percentage_of_job_placement
                      ? (info?.percentage_of_job_placement).toFixed(2)
                      : 0), 1)
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ], 2)), [
    [_directive_loading, _ctx.load]
  ])
}